import { format } from "date-fns";

import axiosResiInstance from "../http/axiosResi";
import { getTrackingId } from "./track";

import * as fb from "../http/fb";
import * as google from "../http/google";
import * as googleAw from "../http/googleAw";
import { randomInt } from "next/dist/shared/lib/bloom-filter/utils";

export const LEAD_TYPE_CONTACT = "contact";
export const LEAD_TYPE_GET_MORE_INFO = "get_more_info";
export const LEAD_TYPE_LISTING = "listing";

export const LEAD_TYPES = [
    { value: LEAD_TYPE_CONTACT, label: "Contact" },
    { value: LEAD_TYPE_GET_MORE_INFO, label: "Get More Info" },
    { value: LEAD_TYPE_LISTING, label: "Listing" },
];

export const LEAD_TYPE_LABELS = {
    [LEAD_TYPE_CONTACT]: "Contact",
    [LEAD_TYPE_GET_MORE_INFO]: "Get More Info",
    [LEAD_TYPE_LISTING]: "Listing",
};

export const LEAD_ONLY_CONTACT_TYPES = [
    { value: LEAD_TYPE_CONTACT, label: "Contact" },
];

export const LEAD_POST_URLS = {
    [LEAD_TYPE_CONTACT]: "contact",
    [LEAD_TYPE_GET_MORE_INFO]: "get-more-info",
    [LEAD_TYPE_LISTING]: "listing",
};

export const LEAD_PAGE_SIZE = 10;

export const postLead = async (type, data, isTest = false) => {
    const trackingId = await getTrackingId();

    if (trackingId) {
        data.tracking_id = trackingId;
    }

    if (isTest) {
        data.is_test = 1;
    }

    return axiosResiInstance
        .post(`/lead/${LEAD_POST_URLS[type]}`, data)
        .then((res) => {
            trackConversion();
            return res;
        });
};

export const fetchLeads = async (page) => {
    return axiosResiInstance.get(`/agent-leads`, {
        params: {
            offset: (page - 1) * LEAD_PAGE_SIZE,
            limit: LEAD_PAGE_SIZE,
        },
    });
};

export const fetchTeamLeads = async (page) => {
    return axiosResiInstance.get(`/agent-team-leads`, {
        params: {
            offset: (page - 1) * LEAD_PAGE_SIZE,
            limit: LEAD_PAGE_SIZE,
        },
    });
};

const getDateString = () => {
    const nowDate = new Date();
    const nowUTC = new Date(
        nowDate.getUTCFullYear(),
        nowDate.getUTCMonth(),
        nowDate.getUTCDate(),
        nowDate.getUTCHours(),
        nowDate.getUTCMinutes(),
        nowDate.getUTCSeconds()
    );

    const hour = format(nowUTC, "HH");
    const second = format(nowUTC, "ss");
    const minute = format(nowUTC, "mm");

    const pos1 = randomInt(5, 9);
    const pos2 = randomInt(5, 9);
    const pos3 = randomInt(5, 9);

    return (
        "" +
        pos1 +
        pos2 +
        pos3 +
        randomInt(Math.pow(10, pos1 - 1), 9 * Math.pow(10, pos1 - 1)) +
        minute +
        randomInt(Math.pow(10, pos2 - 1), 9 * Math.pow(10, pos2 - 1)) +
        hour +
        randomInt(Math.pow(10, pos3 - 1), 9 * Math.pow(10, pos3 - 1)) +
        second +
        randomInt(123456, 923456)
    );
};

export const exportLeads = async (profile) => {
    const dateString = getDateString();

    let token = `${dateString}/${profile.id}/${profile.agent.client_id}/${profile.agent.id}`;
    token = encodeURIComponent(window.btoa(token));

    window.open(
        `${process.env.RESI_API_URL}/agent-leads-export/${token}`,
        "_blank"
    );
};

export const trackConversion = () => {
    fb.trackConversion();
    google.trackConversion();
    googleAw.trackConversion();
};
